import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Estimativa } from 'src/app/models/estimativa.model';
import { EstimativaService } from 'src/app/services/estimativa.service';
import { UtilService } from 'src/app/services/util.service';
import { ValidacaoService } from 'src/app/services/validacao.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { MatDialog } from '@angular/material/dialog';
import * as constants from 'src/app/models/constants/constants'
import { ProjetoService } from 'src/app/services/projeto.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-price-estimativa-component',
  templateUrl: 'price-estimativa.component.html',
  styleUrls: ['./price-estimativa.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PriceEstimativaComponent implements OnInit {

  estimativa: Estimativa;
  enableComposicao: boolean;
  enableCronograma: boolean;
  enableParams: boolean;
  estimate: number;
  estimativaTipoId: number;
  idProject: number;
  enablePricing: boolean;
  enableFatura: boolean;
  somenteLeitura: boolean;
  EditEstimativa = false;
  loading = true;
  isAdmin = false;
  perfilTipo: any;
  usuarioLogin: any;
  statusEstimativa: string;
  clienteNome: string;
  pricingForm: FormGroup;
  isChecked: boolean = false;

  constructor(
    private usuarioService: UsuarioService,
    private projetoService: ProjetoService,
    private estimativaService: EstimativaService,
    private activatedRouter: ActivatedRoute,
    public utilService: UtilService,
    private validacaoService: ValidacaoService,
    private toastr: ToastrComponent,
    private router: Router,
    private dialog: MatDialog,
    private fb: FormBuilder) {
    this.utilService.currentBoolRequisitos.subscribe(b => this.enableComposicao = b);
    this.utilService.currentBoolRequisitos.subscribe(b => this.enableCronograma = b);
    this.utilService.currentBoolComposicao.subscribe(b => this.enableParams = b);
    this.utilService.currentBoolParams.subscribe(b => this.enablePricing = b);

    this.pricingForm = this.fb.group({
      pricingFromStaffPlan: [false]
    });
  }

  ngOnInit() {
    this.isAdmin = this.utilService.isAdmin();
    this.carregar();
    this.estimativaService.getById(this.estimate).subscribe(estimativa => {

      switch (estimativa.statusId) {
        case constants.EstimativaStatusConstants.ID_ESTIMATIVA_ELABORACAO:
          this.statusEstimativa = 'Em elaboração';
          break;
        case constants.EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA:
          this.statusEstimativa = 'Aprovada';
          break;
        case constants.EstimativaStatusConstants.ID_ESTIMATIVA_REPROVADA:
          this.statusEstimativa = 'Reprovada';
          break;
        case constants.EstimativaStatusConstants.ID_ESTIMATIVA_EM_APROVACAO:
          this.statusEstimativa = 'Em Aprovação';
          break;
        case constants.EstimativaStatusConstants.ID_ESTIMATIVA_DESCARTADA:
          this.statusEstimativa = 'Descartada';
          break;
      }

      this.estimativa = estimativa;
      this.idProject = this.estimativa.projetoId;

      this.usuarioService.getById(this.estimativa.usuarioId).subscribe((result: any) => {
        this.usuarioLogin = result.login;
      })

      this.projetoService.getById(this.estimativa.projeto.id).subscribe(result => {
        this.clienteNome = result.cliente.nome;
      });

      this.pricingForm = this.fb.group({
        pricingFromStaffPlan: estimativa.pricingFromStaffPlan ?? false
      });

      this.isChecked = estimativa.pricingFromStaffPlan ?? false;

      this.estimativaTipoId = estimativa.estimativaTipoId;

    })
  }

  carregar() {
    const estimativaId = this.activatedRouter.snapshot.params.id;
    this.estimate = estimativaId;
    this.estimativaService.getById(estimativaId).subscribe(estimativa => {
      this.estimativa = estimativa;

      if (estimativa.statusId !== 1) {
        this.somenteLeitura = true;
      } else {
        this.somenteLeitura = false;
      }

      if (this.estimativa && this.estimativa.estimativaTipoId === 1 || this.estimativa.estimativaTipoId === 3) {
        this.validacaoService.validarRequisitos(estimativaId).subscribe(res => {
          this.enableComposicao = res;
        });

        this.validacaoService.validarComposicaoEquipe(estimativaId).subscribe(res => {
          this.enableParams = res;
        });

        this.validacaoService.validarParametros(estimativaId).subscribe(res => {
          this.enablePricing = res;
        });

      } else if (this.estimativa && this.estimativa.estimativaTipoId === 2) {
        this.enableComposicao = true;
      }

      if (this.estimativa && (this.estimativa.estimativaTipoId === 1 || this.estimativa.estimativaTipoId === 3)) {
        this.enableCronograma = true;
      }
      else {
        this.enableCronograma = false;
      }

    }).add(() => {
      this.loading = false;
    });
  }

  setEditEstimativa() {
    this.EditEstimativa = !this.EditEstimativa;
  }

  updateEstimativa(estimativa) {
    this.loading = true;
    this.estimativaService.update(estimativa).subscribe(() => {
      this.setEditEstimativa();
      this.carregar();
    }, (error) => {
      if (error.status === 400) {
        this.toastr.mostrarMensagem('erro', 'Erro', 'Atualização não permitida. O nome escolhido já é usado em outra estimativa para esta proposta.');
        this.loading = false;
      }
      else {
        this.toastr.mostrarMensagem('erro', 'Erro', 'Ocorreu um erro a atualizar o nome da estimativa, contate o administrador.');
        this.loading = false;
      }
    },
      () => {
        this.loading = false;
      });
  }

  irParaResumo(estimative: any) {
    switch (estimative) {
      case constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_PROJETO:
        this.router.navigate(['price/projeto/estimativa-resumo/' + this.estimativa.id]);
        break;
      case constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_DELIVERY:
        this.router.navigate(['price/projeto/estimativa-resumo/' + this.estimativa.id]);
        break;
      case constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_BODYSHOP:
        this.router.navigate(['price/projeto/estimativa-resumo/' + this.estimativa.id]);
        break;
    }
  }
}
